<template>
<div class="text-center">
  <TriangleHeader :title="$t(exports.cat_title)"/>
  <loading v-if="loading"/>
  <v-row v-else class=" align-center">
    <v-col cols="12" lg="4" xl="4" md="4" class="text-left">
      <img width="80%" :src="exports.topics[0].photo_file" :alt="exports.topics[0].title">
    </v-col>
    <v-col cols="12" lg="8" xl="8" md="8">
      <div class="w-80 mx-auto ma-16" v-html="exports.topics[0].details"></div>
    </v-col>
  </v-row>
  <v-row class="w-90 justify-start mx-auto">
    <v-col cols="6" lg="1" xl="1" md="2" sm="6" v-for="(country,index) in countries.banners" :key="index" class="mt-10">
      <a :href="country.link_url" target="_blank">
        <div class="d-flex justify-center align-center flex-column">
          <v-img width="80" height="40" :src="country.file"></v-img>
          <p class="mt-3 text-center font-weight-bold pointer">{{country.title}}</p>
        </div>
      </a>
    </v-col>
  </v-row>
</div>
</template>

<script>
import {GET_EXPORT} from "../../../store/aboutManagement/action_type";
import {mapState} from "vuex";
import TriangleHeader from "../../../components/triangle_header/TriangleHeader";

export default {
  name: "export",
  components: {TriangleHeader},
  created() {
    this.$store.dispatch(`aboutManagement/${GET_EXPORT}`);
  },
  computed:{
    ...mapState({
      exports : state => state.aboutManagement.exports,
      countries : state => state.aboutManagement.countries,
      loading:state => state.aboutManagement.loading,
    })
  }
}
</script>

<style scoped>

</style>